function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.256775,
  y: 0.959473,
  width: 33.6746,
  height: 33.6746,
  fill: "#D9D9D9"
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_2090_1727)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.2308 28.3211C15.8781 28.3211 15.5831 28.2023 15.3458 27.9647C15.1082 27.7273 14.9894 27.4323 14.9894 27.0797V18.9581L7.13477 8.97989C6.86491 8.62 6.82574 8.24583 7.01726 7.85741C7.20902 7.46874 7.53244 7.27441 7.98751 7.27441H26.2006C26.6557 7.27441 26.9791 7.46874 27.1708 7.85741C27.3624 8.24583 27.3232 8.62 27.0533 8.97989L19.1987 18.9581V27.0797C19.1987 27.4323 19.0799 27.7273 18.8423 27.9647C18.605 28.2023 18.31 28.3211 17.9573 28.3211H16.2308ZM17.094 18.2187L24.0394 9.37908H10.1487L17.094 18.2187Z",
  fill: "url(#paint0_linear_2090_1727)"
}));
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2090_1727",
  x1: 17.094,
  y1: 7.27441,
  x2: 17.094,
  y2: 28.3211,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6510E3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#340679"
})));
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2090_1727",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 35
  }, _ref2), _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.335ccb948e27c697fa9f351d670afefe.svg";
export { ForwardRef as ReactComponent };